import axiosInstance from "./axios";
import {
  CompanyInvoicingType,
  CreateCompanyInvoicingTypePayload,
  UpdateCompanyInvoicingTypePayload,
} from "./models/companyInvoicingType.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const adminFetchCompanyInvoicingTypes = async (
  bearerToken: string,
  companyId: number
): Promise<CompanyInvoicingType[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Admin/companies/${companyId}/invoicingTypes`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch company invoicing types:", error);
    throw error;
  }
};

export const adminCreateCompanyInvoicingType = async (
  bearerToken: string,
  payload: CreateCompanyInvoicingTypePayload
): Promise<CompanyInvoicingType> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Admin/companies/${payload.companyId}/invoicingTypes`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create company invoicing type:", error);
    throw error;
  }
};

export const adminUpdateCompanyInvoicingType = async (
  bearerToken: string,
  payload: UpdateCompanyInvoicingTypePayload
): Promise<CompanyInvoicingType> => {
  try {
    const response = await axiosInstance.patch(
      `${apiUrl}/Admin/companies/${payload.companyId}/invoicingTypes`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update company invoicing type:", error);
    throw error;
  }
};
